import { gsap } from 'gsap'
import { ScrollTrigger } from '../vendor/gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

const workModalInit = () => {
    const modal = document.querySelector('[data-modal-inner]')

    modal.querySelectorAll('[data-scroll-video]').forEach((video) => {
        ScrollTrigger.create({
            scroller: modal,
            trigger: video,
            start: 'top bottom-=100px',
            onEnter: () => video.play()
        })
    })
}

export { workModalInit }
